import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ../~/rc-calendar/es/index.js
// module id = 1023
// module chunks = 1